<div class="row">
    <div class="twelve columns">
        <h2 class="fieldset-title" style="font-size: x-large;">Upload Requests</h2>
    </div>
</div>
<div class="twelve columns">
    <div class="two columns">
        <button soho-button="secondary" icon="refresh" (click)="GetRequestDetails()">Refresh</button>
    </div>
</div>
<div class="row top-padding" soho-busyindicator [blockUI]="true" [text]="Message">
    <div class="twelve columns demo" role="main">
        <div soho-datagrid [columns]="grid_Columns" [data]="data" [selectable]="'single'" [paging]="true"
            [pagesize]="10" filterable="true"></div>
    </div>
</div>